import { Suspense } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { BreadCrumb } from '../BreadCrumb/BreadCrumb';
import { HeaderSearch } from '../HeaderSearch';
import { Icon as CartIcon } from '../../../Cart/components/Icon';
import { Flex } from '../../../GlobalComponents/Flex';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { Icon as StoreIcon } from '../../../Store/components/Icon';
import { isStoreGlobalState, storeState } from '../../../Store/atoms';
import { useRecoilValue } from 'recoil';

import styled from 'styled-components';
import BACK from '../../../assets/imgs/icon/arrow_back.svg';

export type ToolBarProps = React.HTMLAttributes<HTMLDivElement>;

export const ToolBar = (): JSX.Element => {
	const location = useLocation();
	const navigate = useNavigate();

	const storeInfo = useRecoilValue(storeState);
	const isStoreGlobal = useRecoilValue(isStoreGlobalState);

	return (
		<div
			className="d-lg-flex tool-bar py-3 header-tool-bar w-100"
			style={{ maxWidth: 1140 }}
		>
			<div className="container-fluid mx-auto align-items-center d-flex">
				<Bar className="container">
					<Flex
						$alignItems="center"
						$flexDirection="row"
						id="toolbar"
						$width="fit-content"
					>
						{location.pathname !== '/' && (
							<div className="d-lg-none">
								<IconButton
									url={BACK}
									alt={'back'}
									onClick={() => navigate(-1)}
									width={24}
									height={24}
								></IconButton>
							</div>
						)}

						<BreadCrumb className="p-0 mb-0 bg-white d-none d-lg-flex flex-nowrap" />
					</Flex>
					<IconTray>
						<SearchWrapper>
							<Suspense fallback={null}>
								<HeaderSearch />
							</Suspense>
						</SearchWrapper>

						<span
							style={{
								fontSize: '14px',
								lineHeight: '100%',
								whiteSpace: 'nowrap'
							}}
						>
							{storeInfo && !isStoreGlobal
								? `${storeInfo.city}, ${storeInfo.state}`
								: 'Select a Store'}
						</span>

						<StoreIcon />
						<div className="position-relative d-none d-md-flex">
							<CartIcon />
						</div>
					</IconTray>
				</Bar>
			</div>
		</div>
	);
};

const Bar = styled(Flex)`
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0;
	margin: auto;
`;

const IconTray = styled(Flex)`
	width: fit-content;
	margin: 4px 0 4px 10px;
	align-items: center;
	justify-content: flex-end;
	column-gap: 10px;

	@media (max-width: 990px) {
		width: 100%;
	}
`;

const SearchWrapper = styled(Flex)`
	justify-self: flex-end;
	@media (max-width: 768px) {
		justify-self: flex-start;
	}
`;
